module.exports = __webpack_public_path__ + "static/media/appointment.f32571dc.png";